namespace pixi_ui.component {
    import Graphics = PIXI.Graphics;

    export class RoundedRect implements IComponent {
        public color: number;
        public alpha: number;
        public radius: number;
        public rect: Graphics;

        constructor(color: number, alpha: number, radius: number) {
            this.color = color;
            this.alpha = alpha;
            this.radius = radius;
            this.rect = new Graphics();
        }

        public attach(element: Element): void {
            this.rect.beginFill(this.color, this.alpha);
            this.rect.drawRoundedRect(
                0,
                0,
                element.contentWidth,
                element.contentHeight,
                this.radius
            );
            element.addChild(this.rect);
        }

        public detach(element: Element): void {
            element.removeChild(this.rect);
        }

        public resize(element: Element): void {
            this.rect.clear();
            this.rect.beginFill(this.color, this.alpha);
            this.rect.drawRoundedRect(
                0,
                0,
                element.contentWidth,
                element.contentHeight,
                this.radius
            );
        }
    }
}
